import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { ProtectionConfirmationTranslationDictionary } from './protection-confirmation-panel-dictionary.interface';

export const translation: TranslationDictionaryMapping<ProtectionConfirmationTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_PAYMENT: 'First payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_VARIBLE_PROMOTION_PAYMENT:
        'First {{ monthsFree }} payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_PRICE: 'Item Price',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_TAX: 'Item Tax',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT: 'Monthly payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SUBSEQUENT_MONTHLY_PAYMENT:
        'Subsequent monthly payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_NO_VALUE: 'FREE',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_NUMBER: 'Policy number',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_START_DATE:
        'Policy start date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SINGLE_PAYMENT: 'One-time payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TOTAL: 'Total',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TITLE: 'Policy details',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_APPLIANCE: 'Appliance',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_METHOD:
        'Monthly Payment Method',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE:
        'Monthly Payment Date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE_SUFFIX:
        ' of each month',
    },
    [LocaleId.English_Ireland]: {
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_PAYMENT: 'First payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_VARIBLE_PROMOTION_PAYMENT:
        'First {{ monthsFree }} payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_PRICE: 'Item Price',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_TAX: 'Item Tax',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_NO_VALUE: 'FREE',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT: 'Monthly payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SUBSEQUENT_MONTHLY_PAYMENT:
        'Subsequent monthly payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_NUMBER: 'Policy number',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_START_DATE:
        'Policy start date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SINGLE_PAYMENT: 'One-time payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TOTAL: 'Total',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TITLE: 'Policy details',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_APPLIANCE: 'Appliance',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_METHOD:
        'Monthly Payment Method',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE:
        'Monthly Payment Date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE_SUFFIX:
        ' of each month',
    },
    [LocaleId.English_US]: {
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_PAYMENT: 'First payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_FIRST_VARIBLE_PROMOTION_PAYMENT:
        'First {{ monthsFree }} payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_PRICE: 'Item Price',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_TAX: 'Item Tax',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_NO_VALUE: 'FREE',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT: 'Monthly payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SUBSEQUENT_MONTHLY_PAYMENT:
        'Subsequent monthly payments',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_NUMBER: 'Policy number',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_START_DATE:
        'Policy start date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_SINGLE_PAYMENT: 'One-time payment',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TOTAL: 'Total',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TITLE: 'Policy details',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_APPLIANCE: 'Appliance',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_METHOD:
        'Monthly Payment Method',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE:
        'Monthly Payment Date',
      CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE_SUFFIX:
        ' of each month',
    },
  };
